import React from "react";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import NestedTabsComponent from "../nested-tabs-component";
import { TOOLS_TYPE, NESTED_SIDENAV, ACCESS_CONFIG } from "../strings";

const Tools = () => {
  const { t } = useTranslation();
  const { MARKETING_MANAGER_TIER } = ACCESS_CONFIG;
  return (
    <div className="d-flex h-100">
      <div className="sub-sidebar">
        <div className="inner-sub-sidebar">
          <div className="tab-heading ps-3 mt-4">{t("tools")}</div>
          <NestedTabsComponent
            nestedNavType={NESTED_SIDENAV.TOOLS}
            tabs={[
              {
                evKey: TOOLS_TYPE.DUPLICATOR,
                title: t("adDuplicator.title"),
                access: MARKETING_MANAGER_TIER
              },
              {
                evKey: TOOLS_TYPE.WEBSITE_CREATION_LOGS,
                title: "Website Creation Logs",
                access: MARKETING_MANAGER_TIER
              }
            ]}
          />
        </div>
      </div>
      <div className="outlet-wrapper">
        <Outlet />
      </div>
    </div>
  );
};
export default Tools;
